<h2 mat-dialog-title>{{ 'GeneralMeeting.ImportVotes' | translate }}</h2>
<mat-dialog-content class="d-flex flex-column dialog-content-max-height">
    @if (!isVotingOpen()) {
        <form [formGroup]="startVotingFormGroup" (submit)="openVoting()" class="d-flex flex-column">
            <sl-input
                [control]="startVotingFormGroup.controls.couponNr"
                placeholderKey="AgendaItemSettings.CouponNo"
                inputPlaceholderKey="GeneralMeeting.CouponNrEmptyAuto" />
            <mat-form-field>
                <mat-label>
                    {{ 'GeneralMeeting.DefaultVoteOption' | translate }}
                </mat-label>
                <mat-select [formControl]="startVotingFormGroup.controls.defaultVote">
                    <mat-option [value]="VoteOptionEnum.NoVote">
                        {{ 'Voting.NotVoted' | translate }}
                    </mat-option>
                    <mat-option [value]="VoteOptionEnum.Yes">
                        {{ 'Voting.Yes' | translate }}
                    </mat-option>
                    <mat-option [value]="VoteOptionEnum.No">
                        {{ 'Voting.No' | translate }}
                    </mat-option>
                    <mat-option [value]="VoteOptionEnum.Abstention">
                        {{ 'Voting.Abstain' | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            @if (!isStartingVote()) {
                <button mat-flat-button class="w-100" color="primary" type="submit">{{ 'GeneralMeeting.StartVoting' | translate }}</button>
            } @else {
                <mat-spinner [diameter]="36" class="mx-auto" />
            }
        </form>
    } @else {
        <p>{{ 'GeneralMeeting.Id' | translate }}: {{ generalMeetingId() }}</p>
        <p>{{ 'AgendaItemSettings.CouponNo' | translate }}: {{ votingCouponNumber() }}</p>

        <form [formGroup]="formGroup" (submit)="submit()" class="d-flex flex-column">
            <mat-form-field>
                <mat-label>
                    {{ 'GeneralMeeting.ImportType' | translate }}
                </mat-label>
                <mat-select [formControl]="formGroup.controls.importType" (selectionChange)="importTypeChanged()">
                    <mat-option [value]="ImportTypesEnum.Barcode">
                        {{ 'GeneralMeeting.Barcode' | translate }}
                    </mat-option>
                    <mat-option [value]="ImportTypesEnum.FileImport">
                        {{ 'GeneralMeeting.FileImport' | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>
                    {{ 'GeneralMeeting.Vote' | translate }}
                </mat-label>
                <mat-select [formControl]="formGroup.controls.vote">
                    <mat-option [value]="VoteOptionEnum.NoVote" [disabled]="formGroup.value.importType === ImportTypesEnum.FileImport">
                        {{ 'GeneralMeeting.AutoFromBarcode' | translate }}
                    </mat-option>
                    <mat-option [value]="VoteOptionEnum.Yes">
                        {{ 'Voting.Yes' | translate }}
                    </mat-option>
                    <mat-option [value]="VoteOptionEnum.No">
                        {{ 'Voting.No' | translate }}
                    </mat-option>
                    <mat-option [value]="VoteOptionEnum.Abstention">
                        {{ 'Voting.Abstain' | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            @if (formGroup.controls.barcode) {
                <sl-input [control]="formGroup.controls.barcode" placeholderKey="GeneralMeeting.Barcode" #barcodeField />
            }
            @if (formGroup.controls.importFile && formGroup.controls.importFileContent) {
                <mat-form-field floatLabel="always">
                    <mat-label>{{ 'FileUpload.SelectFile' | translate }}</mat-label>
                    <input
                        type="file"
                        class="w-100"
                        (change)="fileSelected($any($event.target).files)"
                        [formControl]="formGroup.controls.importFile" />
                    <input class="d-none" matInput [formControl]="formGroup.controls.importFileContent" />
                    <mat-error>
                        <sl-form-field-error-control [control]="formGroup.controls.importFileContent" />
                    </mat-error>
                </mat-form-field>
            }
            @if (!isImporting()) {
                <button mat-flat-button class="w-100" color="primary" type="submit">{{ 'General.Save' | translate }}</button>
            } @else {
                <mat-spinner [diameter]="36" class="mx-auto" />
            }
        </form>
        <mat-divider horizontal class="my-3" />
        <div class="overflow-auto">
            <table mat-table [dataSource]="importedVotesObservable">
                <ng-container matColumnDef="successful">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let item">
                        <mat-icon [ngClass]="item.successful ? 'success' : 'error'">{{ item.successful ? 'check' : 'close' }}</mat-icon>
                    </td>
                </ng-container>
                <mat-text-column name="barcode" [headerText]="'GeneralMeeting.Barcode' | translate" />
                <mat-text-column name="message" [headerText]="'GeneralMeeting.VoteImportResult' | translate" />
                <ng-container matColumnDef="voteOption">
                    <th mat-header-cell *matHeaderCellDef>{{ 'GeneralMeeting.Vote' | translate }}</th>
                    <td mat-cell *matCellDef="let item">
                        {{ (item.voteOption === VoteOptionEnum.Yes ? 'Voting.Yes' : '') | translate }}
                        {{ (item.voteOption === VoteOptionEnum.No ? 'Voting.No' : '') | translate }}
                        {{ (item.voteOption === VoteOptionEnum.Abstention ? 'Voting.Abstain' : '') | translate }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="resetVoteButton">
                    <th mat-header-cell *matHeaderCellDef>{{ 'GeneralMeeting.ResetVote' | translate }}</th>
                    <td mat-cell *matCellDef="let item">
                        @if (item.successful) {
                            <button mat-icon-button (click)="resetVote(item)">
                                <mat-icon>undo</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="shouldRefreshAfterClose()">{{ 'General.Close' | translate }}</button>
</mat-dialog-actions>
